import React, { useCallback } from 'react';
import { GeoJSON } from 'react-leaflet';
import { mapDataKey } from 'utils/map/MapCalculations';
import { colors, tourColors } from '../../global/variables';
import { AREA_TYPES } from '../../utils/territories/TerritoriesFromJson';

const { transparentDarkerColor, areas, avoidArea } = colors;

const MapAreas = ({ areaPolygon, onClick, groupsToShow, tourData }) => {
  const showName = useCallback(
    (e) => {
      if (onClick) onClick(e.target.feature.properties);
    },
    [onClick],
  );

  const getVehicleIdByTerritoryId = (vehicles, territoryId) => {
    return (
      vehicles?.find((vehicle) =>
        vehicle.territories?.items.some((item) => item.id === territoryId),
      )?.id || null
    );
  };

  const onHandleSelectArea = (feature, layer) => {
    layer.on({
      click: showName,
      mouseover: (e) => {
        if (layer instanceof L.Polygon) {
          layer.setStyle({ weight: 3 });
        }

        const type =
          feature.properties.type.charAt(0).toUpperCase() + feature.properties.type.slice(1);
        const isConcave = type.toLowerCase().includes('concave');
        const isConvex = type.toLowerCase().includes('convex');
        const vehicleId = getVehicleIdByTerritoryId(
          tourData?.fleet?.types,
          feature.properties.name,
        );
        const isGroup = type === 'Group';
        const isAvoid = type === 'Avoid_area';
        const isExclude = type === 'Exclude_area';

        const popup = L.popup()
          .setLatLng(e.latlng)
          .setContent(
            `${vehicleId ? `Tour: <b>${vehicleId}</b></br>` : ''}
          ${
            feature.properties.groupName || isGroup
              ? `Group: <b>${
                  isGroup ? feature.properties.name : feature.properties.groupName
                }</b></br>`
              : ''
          }
          ${isAvoid ? `Avoid: <b>${feature.properties.name}</b></br>` : ''}
          ${isExclude ? `Exclude: <b>${feature.properties.name}</b></br>` : ''}
          ${isConcave ? `vehicleId: <b>${feature.properties.name}</b></br>` : ''}
          ${isConvex ? `vehicleId: <b>${feature.properties.name}</b></br>` : ''}
          ${
            !isConcave &&
            !isConvex &&
            !feature.properties.groupName &&
            !isGroup &&
            !isAvoid &&
            !isExclude
              ? `Territory: <b>${feature.properties.name} (${type})</b></br>`
              : ''
          }`,
          )
          .openOn(layer._map);

        layer.on('mousemove', (ev) => {
          popup.setLatLng(ev.latlng);
        });
      },
      mouseout: () => {
        if (layer instanceof L.Polygon) {
          layer.setStyle({ weight: 2 });
        }
        layer._map.closePopup();
      },
    });
  };

  const getPolygonStyle = (polygon) => {
    const { index, type } = polygon.properties;
    const isAvoidPolygon = type === AREA_TYPES.AVOID_AREA;
    const isExcludeArea = type === AREA_TYPES.EXCLUDE_AREA;
    const isGroupPolygon = type === AREA_TYPES.GROUP;
    const isTourHull =
      type === AREA_TYPES.TOUR_HULL_CONCAVE || type === AREA_TYPES.TOUR_HULL_CONVEX;

    const tourColor = tourColors[index % tourColors.length].delivery.inner;
    const fillColor =
      isAvoidPolygon || isExcludeArea ? avoidArea : isTourHull ? tourColor : areas[index];
    const dashArray =
      isGroupPolygon || isAvoidPolygon || isExcludeArea ? '4' : isTourHull ? '20' : undefined;
    const color =
      isAvoidPolygon || isExcludeArea ? avoidArea : isTourHull ? tourColor : transparentDarkerColor;

    return {
      opacity: 1,
      weight: 2,
      color,
      fillColor,
      dashArray,
    };
  };
  return areaPolygon.features.map((feature, i) => {
    return (
      <GeoJSON
        key={`${mapDataKey(areaPolygon, i, groupsToShow, undefined)}-area`}
        data={feature}
        style={getPolygonStyle}
        onEachFeature={onHandleSelectArea}
      />
    );
  });
};
export default MapAreas;
